import { useUnmount } from 'ahooks';
import { Col, Row } from 'antd';

import { Container, Loader, TitledContainer } from 'components';

import {
  Overview,
  ReceiptImg,
  SnapActions,
  SnapTabs,
  Title,
  TitleExtraNode,
} from './components';
import { useSnapDetails } from './hooks';
import { resetSnapAction } from './store';

export const Snap = () => {
  const { loading } = useSnapDetails();

  useUnmount(() => {
    resetSnapAction();
  });

  return (
    <Loader
      isFullHeight
      isLoading={loading}
    >
      <TitledContainer
        backLink
        isFullHeight
        title={<Title />}
        titleExtraNode={<TitleExtraNode />}
        underTitleNode={<SnapActions />}
      >
        <Container>
          <Row gutter={24} className='h-full'>
            <Col xs={8} xxl={6} className='h-full'>
              <Container
                noIndents
                scrollable
              >
                <ReceiptImg />
              </Container>
            </Col>

            <Col xs={16} xxl={18} className='h-full'>
              <Container
                noIndents
                scrollable
              >
                <Overview />

                <SnapTabs />
              </Container>
            </Col>
          </Row>
        </Container>
      </TitledContainer>
    </Loader>
  );
};
